module.exports = __webpack_public_path__ + "img/storebanner.478decba.png";